<template lang="html">
  <v-layout row>
    <v-flex xs12>
      <v-card class>
        <v-card-title primary-title class="grey lighten-4">
          <v-tooltip top>
                  <v-btn
                        slot="activator"
                        dark
                        @click.stop="helpdialog = true"
                        icon class="mx-0">
                     <v-icon color="red">help</v-icon>
                 </v-btn>
             <span>Cobranza/Conciliación</span>
          </v-tooltip>
          <h3 class="headline mb-0">Conciliación Bancaria</h3>
          <v-spacer></v-spacer>
          <!-- <v-btn color="primary" dark class="mb-2" @click="nuevoUsuario">Agregar</v-btn> -->
        </v-card-title>
          <v-card-title primary-title class="grey lighten-4">
             <v-radio-group v-model="status" @change="changeSolv">
                <v-radio color="primary" label="PENDIENTE" value="PENDIENTE"></v-radio>
                <v-radio color="primary" label="PAGADO" value="PAGADO"></v-radio>
                <v-radio color="primary" label="ANULADO" value="ANULADO"></v-radio>
            </v-radio-group>
            <v-spacer></v-spacer>
            <v-switch
                v-if="status == 'PENDIENTE'"
                color="primary"
                @change="changeSolv"
                v-model="filtro_pagos"
                label="Servicios con pagos"
            ></v-switch>
            <v-spacer></v-spacer>
            <v-text-field
              :loading="loading"
              v-model="search"
              label="Buscar"
              single-line
              hide-details
              :append-outer-icon="loading ? 'update' : 'search'"
              @change="searchFilterConciliacion"
            ></v-text-field>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text style="padding: 0">
            <v-data-table
                :loading="loading"
                :headers="headers"
                :items="conciliaciones"
                rows-per-page-text="Filas por Pág"
                :pagination.sync="pagination"
                :total-items="total"
                :rows-per-page-items="rowsPerPageItems"
                row
                wrap
                pl-0
                ml-0
                pr-0
                mr-0
                class="elevation-0"
             >
               <template slot="items" slot-scope="props">

                 <td align="center">{{ props.item.unionize == null || props.item.unionize.cpc == null ? 'N/A' : props.item.unionize.cpc }}</td>
                 <td align="left">{{ props.item.rif }} {{ props.item.razon_social }}</td>
                 <!-- <td>{{ props.item.payments[0].way_to_pay }}</td> -->
                 <td align="center">
                    {{ props.item ? props.item.cant_pagos : 0 }}
                     <v-chip :color="props.item.status == 'PAGADO' ? 'teal' : props.item.status == 'PENDIENTE' ? 'orange' : 'red'" text-color="white" @click="changeStatusDialog(props)">
                        {{ props.item.status }}
                    </v-chip>
                 </td>
                 <!-- <td>{{ props.item.payments[0].number }}</td> -->
                 <!-- <td>{{ props.item.payments[0].payment_date }}</td> -->
                 <td align="center">#{{ props.item.id }}</td>
                 <td align="center">{{ new Intl.NumberFormat("de-DE").format(props.item.amount) }}</td>
                 <td align="center">{{ props.item.monto_pago ? new Intl.NumberFormat("de-DE").format(props.item.monto_pago) : 0 }}</td>

                 <td class="justify-center layout px-0">
<!-- 
                    <v-tooltip top>
                        <v-btn slot="activator" icon class="mx-0" @click="editarConciliacion(props)">
                          <v-icon color="info">edit</v-icon>
                        </v-btn>
                        <span>Editar Conciliación</span>
                    </v-tooltip> -->
                    <v-tooltip top>
                        <v-btn @click="printFactura(props.item)" slot="activator" icon class="mx-0" >
                            <v-icon color="primary">web</v-icon>
                        </v-btn>
                        <span>Visualizar Dcto.#{{ props.item.id }}</span>
                    </v-tooltip>
                    <v-tooltip top v-if="props.item.status == 'PENDIENTE'">
                      <v-btn slot="activator" icon class="mx-0" @click="anulacionDialog(props.item)">
                        <v-icon color="error">no_sim</v-icon>
                      </v-btn>
                      <span>Anular Factura</span>
                    </v-tooltip>
                    <v-tooltip top v-if="props.item.status == 'PENDIENTE'">
                      <v-btn slot="activator" icon class="mx-0" @click="registrarPago(props.item)">
                        <v-icon color="success">account_balance_wallet</v-icon>
                      </v-btn>
                      <span>Registrar Pago</span>
                    </v-tooltip>

                </td>
               </template>
               <v-alert slot="no-results" :value="true" color="error" icon="warning">
                 La busqueda para  "{{ search }}" No resultó.
               </v-alert>
             </v-data-table>

          </v-card-text>
      </v-card>
    </v-flex>

    <!-- dialog para form invoice status -->
    <v-dialog v-model="dialogChangeStatus" width="600" persistent>
      <formInvoiceStatus :loading="loading" :datos="getInvoice" v-on:closeDialogInvoiceStatus="closeDialogInvoiceStatus($event)" v-on:responseLoading="loading = $event"/>
    </v-dialog>
    <!-- fin dialog para form invoice status -->

    <!-- dialog para form registrar pago -->
    <v-dialog v-model="dialogRegistrarPago" width="600" persistent>
      <formRegistrarPago :loading="loading" :datos="registroPagoItem" v-on:closeDialogRegistrarPago="closeDialogRegistrarPago($event)" v-on:responseLoading="loading = $event"/>
    </v-dialog>
    <!-- fin dialog para form registrar pago -->

    <!-- dialog para form invoice edit -->
    <!-- <v-dialog v-model="dialogEdit" width="600" persistent>
      <formInvoiceEdit :loading="loading" :datos="getInvoice" v-on:closeDialogInvoiceEdit="closeDialogInvoiceEdit($event)" v-on:responseLoading="loading = $event"/>
    </v-dialog> -->
    <!-- fin dialog para form invoice edit -->

    <!-- loading -->
    <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="300"
    >
        <v-card
            color="primary"
            dark
        >
            <v-card-text>
            Porfavor Espere...
            <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
            ></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>

    <!-- Inicio de dialogo de ayuda -->
    <v-dialog v-model="helpdialog" max-width="600">
          <v-card>
            <v-card-title class="headline">Conciliación de pagos</v-card-title>
            <v-card-text>
              Sección para acentar en el sistema que se ha recibido el pago correspondiente a la actuación profesional registrada.
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" flat="flat" @click="helpdialog = false">
                Salir
              </v-btn>
            </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Fin de dialogo -->

            <!-- dialog para anular invoice -->
        <v-dialog v-model="dialogAnulacion" width="500" persistent>
            <v-card hover flat>
                <v-form ref="formanular" v-model="valid" lazy-validation enctype="multipart/form-data">
                    <v-card-text>
                        <p>Describa el motivo de invalidación en la factura número <strong>{{formAnulacion.id}}:</strong></p>
                        <v-textarea
                            v-model="formAnulacion.motivo_anulacion"
                            prepend-icon="insert_comment"
                            auto-grow
                            box
                            color="primary"
                            label="Motivo de anulacion"
                            rows="2"
                            required
                            :rules="[v => !!v || 'El motivo de anulación es requerido']"
                        ></v-textarea>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn @click="cerrarDialogAnular">Cerrar</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn :loading="loading" class="primary" @click="aprobAnulacion">Anular</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <!-- fin dialog para anular invoice -->

        <v-layout row justify-center>
            <v-dialog v-model="print" persistent max-width="800px">
                <v-card>
                    <v-card-title>
                        <span class="headline">Factura</span>
                    </v-card-title>
                    <v-card-text>
                        <FacturaPagoConciliacion :data="dataFactura" v-if="print"/>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary darken-1" @click="print = false">Cerrar</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn v-if="dataFactura.status == 'PAGADO' || dataFactura.status == 'SOLV-PAGADO'" :loading="loading" color="primary darken-1" flat v-print="'#printMe'">Imprimir Factura</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

  </v-layout>
</template>

<script>
import axios from 'axios'
import Form from 'vform'
import { mapGetters } from 'vuex'
import formInvoiceStatus from '~/pages/cobranza/formInvoiceStatus'
import formInvoiceEdit from '~/pages/cobranza/formInvoiceEdit'
import formRegistrarPago from '~/pages/cobranza/FormRegistroPago'
import FacturaPagoConciliacion from '~/components/factura/FacturaPagoConciliacion.vue'

export default {

    name: 'cobranza-conciliacion-view',

    components: {
        formInvoiceStatus,
        formInvoiceEdit,
        formRegistrarPago,
        FacturaPagoConciliacion
    },

    computed: {
        ...mapGetters({
            authenticated: 'authCheck'
        }),
        getInvoice () {
            return this.editItem
        },
    },

    watch: {
        pagination() {
            this.getConciliacionByPagination();
        }
    },

    data () {
        return {
            print: false,
            valid: false,
            dialog: false,
            status: 'PENDIENTE',
            filtro_pagos: true,
            dialogAnulacion: false,
            formAnulacion: new Form({
              id: '',
              motivo_anulacion: '',
            }),
            dialogChangeStatus: false,
            dialogRegistrarPago: false,
            helpdialog: false,
            dialogEdit: false,
            conciliaciones: [],
            activePagination: false,
            total: 0,
            dataFactura: {},
            pagination: {},
            loading: false,
            tipo: '',
            search: '',
            editItem: {},
            registroPagoItem: {},
            headers: [
                { text: 'CPC', sortable: false, align: 'center' },
                { text: 'RIF/RAZON SOCIAL DEL CLIENTE', value: 'razon_social', sortable: false, align: 'left' },
                // { text: 'METODO DE PAGO', value: 'way_to_pay', sortable: false },
                { text: 'ESTATUS', value: 'status', sortable: false, align: 'center' },
                // { text: 'FECHA DE PAGO', value: 'payment_date', sortable: false, align: 'center' },
                { text: 'NRO. FACT.', value: 'id', sortable: false, align: 'center' },
                { text: 'MONTO FACT.', value: 'amount', sortable: false, align: 'center' },
                { text: 'ACUM. PAGOS', value: 'pagado', sortable: false, align: 'center' },
                // { text: 'NUM TRANSACCION', value: 'number', sortable: false, align: 'center' },
                { text: 'Acciones', value: 'acciones', sortable: false, align: 'center' }
            ],
            rowsPerPageItems: [10, 20, 50, 100],
        }
    },

    methods: {

        changeSolv() {
            if (this.status != 'PENDIENTE') {
                this.filtro_pagos = true
            }
            this.getConciliacionByPagination();
        },

        async getConciliacionByPagination () {
            this.loading = true;
            if (this.search) {
                await axios.get(`/api/administration/cobranza/conciliacion-filter?query=${this.search}&page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}&per_status=${this.status}&per_pagos=${this.filtro_pagos}`)
                    .then(res => {
                        this.conciliaciones = res.data.data;
                        this.total = res.data.total;
                    })
                    .catch(e => {
                        console.log(e.response)
                    })
                    .finally(() => this.loading = false);
            }
            if (this.pagination.sortBy && !this.search) {
                const direction = this.pagination.descending ? 'desc' : 'asc';
                await axios.get(`/api/administration/cobranza/conciliacion-order?direction=${direction}&sortBy=${this.pagination.sortBy}&page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}&per_status=${this.status}&per_pagos=${this.filtro_pagos}`)
                    .then(res => {
                        this.conciliaciones = res.data.data;
                        this.total = res.data.total;
                    })
                    .finally(() => this.loading = false);
            }
            if(!this.search && !this.pagination.sortBy) {
                await axios.get(`/api/administration/cobranza/conciliacion?page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}&per_status=${this.status}&per_pagos=${this.filtro_pagos}`)
                    .then(res => {
                        this.conciliaciones = res.data.data;
                        this.total = res.data.total;
                    })
                    .finally(() => this.loading = false);
            }
        },

        searchFilterConciliacion () {
            this.getConciliacionByPagination()
        },

        changeStatusDialog (props) {
            // if(props.item.status == 'PENDIENTE'){
                this.editItem = props.item
                this.dialogChangeStatus = true
            // }
        },

        editarConciliacion (props) {
            this.editItem = props.item
            this.dialogEdit = true
        },

        closeDialogInvoiceStatus(response) {
            if (response != null) {
                this.getConciliacionByPagination();
            }
            this.dialogChangeStatus = false
        },

        closeDialogInvoiceEdit(response) {
            if (response != null) {
                this.getConciliacionByPagination();
            }
            this.dialogEdit = false
        },

        cerrarDialogAnular () {
            this.dialogAnulacion = false
            this.$nextTick(() => {
                this.$refs.formanular.resetValidation()
                this.formAnulacion.motivo_anulacion = ''
                this.loading = false
            })
        },

        anulacionDialog (item) {
          this.formAnulacion.id = item.id
          this.dialogAnulacion = true
        },

        async aprobAnulacion () {
          if (this.$refs.formanular.validate()) {
              this.loading = true
              await axios.post('/api/administration/cobranza/conciliacion-change-status',{ id: this.formAnulacion.id, status: 'ANULADO', motivo_anulacion: this.formAnulacion.motivo_anulacion })
              .then((resp) => {
                  this.$store.dispatch('responseMessage', {
                      type: 'success',
                      text: `Cambio de estatus a ANULADO exitoso`
                  })
                  this.getConciliacionByPagination()
                  this.cerrarDialogAnular()
              }).catch((error) => {
                  console.log(error.response)
                  if(error.response){
                      if(error.response.status == 404){
                          this.$store.dispatch('responseMessage', {
                              type: 'error',
                              text: 'No se encontro la factura, intente nuevamente.'
                          })   
                      }else if(error.response.status == 403) {
                          this.$store.dispatch('responseMessage', {
                              type: 'error',
                              text: 'No es posible actualizar esta factura.'
                          })  
                      }
                  } else {
                      console.log('Error', error.message);
                  }
              }).finally(() => this.loading = false)
          }
        },

        async printFactura(item) {
            console.log(item)
          this.dataFactura = item
          this.print = true
        },

        registrarPago(item) {
            this.registroPagoItem = item
            this.dialogRegistrarPago = true
        },

        closeDialogRegistrarPago(response) {
            if (response != null) {
                this.getConciliacionByPagination();
            }
            this.dialogRegistrarPago = false
        },


    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/cobranza/ConciliacionBancaria.vue